import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["arrivalTimes", "departureTimes"]

  connect() {
    this.toggleFields()
  }

  toggleFields() {
    const visitType = this.element.querySelector('select[name="train_visit[visit_type]"]').value

    if (visitType === 'inbound') {
      this.arrivalTimesTarget.classList.remove('hidden')
      this.departureTimesTarget.classList.add('hidden')
      this.clearDepartureTimes()
    } else if (visitType === 'outbound') {
      this.arrivalTimesTarget.classList.add('hidden')
      this.departureTimesTarget.classList.remove('hidden')
      this.clearArrivalTimes()
    }
  }

  clearArrivalTimes() {
    const fields = [
      'estimated_time_of_arrival',
      'actual_time_of_arrival'
    ]

    fields.forEach(field => {
      const inputs = this.element.querySelectorAll(`input[name*="${field}"]`)
      inputs.forEach(input => input.value = '')
    })
  }

  clearDepartureTimes() {
    const fields = [
      'estimated_time_of_departure',
      'actual_time_of_departure'
    ]

    fields.forEach(field => {
      const inputs = this.element.querySelectorAll(`input[name*="${field}"]`)
      inputs.forEach(input => input.value = '')
    })
  }
}
